import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import App from './App';
import { MaterialViewer } from './ui/MaterialViewer';
import { useGameStore } from './state/store';
import './index.css';

// Dev-only: expose the store for scripted verification (Playwright drives debug toggles through
// it — no UI scraping). Stripped from production builds.
if (import.meta.env.DEV) {
  (window as unknown as Record<string, unknown>).__worldifyStore = useGameStore;
}

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<App />} />
        <Route path="/materials" element={<MaterialViewer />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
);
